import type { AuthUser } from '@/lib/api';
import { userPreferencesApi } from '@/lib/api';
import { isSuperAdmin } from '@/lib/auth-roles';
import { isValidCpf } from '@/lib/cpf';
import { isValidPhone } from '@/lib/phone-br';
import { homePagePathFromPreference, type HomePagePreference } from '@/lib/user-preferences';

export function isProfileComplete(
  user: Pick<AuthUser, 'name' | 'phone' | 'cpf' | 'profileComplete' | 'role'> | null | undefined
): boolean {
  if (!user) return false;
  if (isSuperAdmin(user)) return true;
  if (user.profileComplete === true) return true;
  if (user.profileComplete === false) return false;

  const name = user.name?.trim();
  if (!name || name.length < 2) return false;
  if (!user.phone || !isValidPhone(user.phone)) return false;
  if (!user.cpf || !isValidCpf(user.cpf)) return false;
  return true;
}

export function postAuthRedirect(
  user: AuthUser,
  next?: string | null,
  homePage?: HomePagePreference | null
): string {
  if (!isProfileComplete(user)) return '/completar-cadastro';
  if (next && next.startsWith('/') && !next.startsWith('/login')) return next;
  return homePagePathFromPreference(homePage ?? 'dashboard');
}

/** Após login/OAuth: respeita `next`, senão busca a página inicial nas preferências do usuário. */
export async function resolvePostAuthRedirect(
  user: AuthUser,
  next?: string | null
): Promise<string> {
  if (!isProfileComplete(user)) return '/completar-cadastro';
  if (next && next.startsWith('/') && !next.startsWith('/login')) return next;
  try {
    const prefs = await userPreferencesApi.get();
    return homePagePathFromPreference(prefs.preferences.general.homePage);
  } catch {
    return homePagePathFromPreference('dashboard');
  }
}
